const ENCODING = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';

/** Minimal ULID: 48-bit time + 80 bits randomness, Crockford base32. */
export function ulid(now: number = Date.now()): string {
  let t = now;
  let time = '';
  for (let i = 0; i < 10; i++) {
    time = ENCODING[t % 32]! + time;
    t = Math.floor(t / 32);
  }
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  let rand = '';
  for (let i = 0; i < 16; i++) rand += ENCODING[bytes[i]! % 32]!;
  return time + rand;
}
